import { PublisherDashboardContent } from './PublisherDashboardContent';

export function PublisherDashboardPage({ publisherId }: { publisherId: string }) {
  return (
    <main className="page-gutter mx-auto w-full max-w-[1920px] min-w-0 space-y-6 py-5">
      <PublisherDashboardContent publisherId={publisherId} />
    </main>
  );
}
